import { TopicType } from '@uniquegood/realworld-admin-interface';

export const topicTypeToString: Record<TopicType, string> = {
  [TopicType.Integrate]: '모집/잡담 가능 토픽',
  [TopicType.Recruitment]: '모집 전용 토픽',
  [TopicType.Talk]: '잡담 전용 토픽',
  [TopicType.Notice]: '공지사항 전용 토픽'
};
